require("core-js/modules/es6.array.map");

var _ = require('lodash');

var className = 'transition';

module.exports = function (_ref) {
  var standard = _ref.standard,
      transitions = _ref.transitions,
      variants = _ref.variants;
  return function (_ref2) {
    var _$concat;

    var addUtilities = _ref2.addUtilities,
        e = _ref2.e;

    var utilities = _.map(transitions, function (val, name) {
      var _ref3;

      return _ref3 = {}, _ref3["." + e(className + "-" + name)] = {
        transition: val
      }, _ref3;
    });

    if (standard) utilities = _.concat(utilities, (_$concat = {}, _$concat["." + className] = {
      transition: standard
    }, _$concat));
    addUtilities(utilities, variants);
  };
};